import QRCode from 'react-qr-code'
import { DataTestIDs } from 'shared/constants'
import { NeonPanel } from 'shared/ui/neon'
import { CopyAddressButton } from './copy-address-button'
import styles from '../neon-wallets.module.scss'

const QR_SIZE = 256

interface Props {
  address: string
}

/**
 * The wallet's address as a QR code and as text. A plain address, not a
 * `solana:` link, so exchange withdrawal forms can scan it too.
 */
export const DepositAddress: React.FC<Props> = ({ address }) => (
  <NeonPanel
    glow='cyan'
    padding='1'
    gap='3'
    align='center'
    className={styles.qrCard}
  >
    <div className={styles.qrFrame}>
      <QRCode
        value={address}
        size={QR_SIZE}
        title='Wallet address QR code'
        style={{ height: 'auto', maxWidth: '100%', width: '100%' }}
      />
    </div>
    <span
      className={styles.qrAddress}
      data-testid={DataTestIDs.walletDepositAddress}
    >
      {address}
    </span>
    <CopyAddressButton
      address={address}
      variant='button'
      testId={DataTestIDs.buttonWalletDepositCopy}
    />
  </NeonPanel>
)
